import { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Results from "../components/Result";
import ProductSlider from "../components/ProductSlider";
import searchimage from "../images/search-vector.png"



export const UserData = () => {
  const [clickedButtonIndex, setClickedButtonIndex] = useState(null);
  const [clickedButtonGender, setClickedButtonGender] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageURL, setSelectedImageURl] = useState(null);
  const [selectedStyle, setSelectedStyle] = useState("");
  const [selectedGender, setSelectedGender] = useState("");

  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [age, setAge] = useState("");
  const [generatedImage, setGeneratedImage] = useState(null);
  const [keywords, setKeywords] = useState(null);
  const [products, setProducts] = useState(null);
  const [recordId, setRecordId] = useState(null);
  const [description, setDescription] = useState(null);
  const [input_image_url, setInput_image_url] = useState(null);
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setSelectedImageURl(URL.createObjectURL(file));
    setSelectedImage(file);
  };

  const HandleBtn = (index, name) => {
    setClickedButtonIndex(index);
    setSelectedStyle(name);
  };
  const HandleGender = (index, gendername) => {
    setClickedButtonGender(index);
    setSelectedGender(gendername);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="data_container py-3 py-lg-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="text-white mb-5"></h2>

            <form onSubmit={handleSubmit}>
              <div className="form_container d-flex flex-column justify-content-center align-items-center">

                <div className="imageUploader_container w-100">
                  <label
                    htmlFor="upload"
                    className="upload-button mb-5 btn_form border-dashed"
                  >
                    Click to Image for Upload....
                    <input
                      type="file"
                      id="upload"
                      style={{ display: "none" }}
                      onChange={handleImageUpload}
                    />
                  </label>
                </div>

                <div className="Image_Selected_Result mb-5">
                  {selectedImageURL && (
                    <div className="image-select-img">
                      <img
                        src={selectedImageURL}
                        alt="Uploaded"
                        className="img-fluid rounded"
                      />
                    </div>
                  )}
                </div>

                <div className="SelectStyle_container">
                  <h3 className="text-white">Select Your Style</h3>
                  <div className="search_container d-flex flex-row justify-content-center align-items-center mb-5 btn_form">
                    <img src={searchimage} alt="search" className="img-fluid" />
                    <Form.Group>
                      <Form.Control type="search" icon="search" placeholder={ selectedStyle ? selectedStyle.name : "find style" } />
                    </Form.Group>
                  </div>
                  <div className="button_container mb-4 d-flex justify-content-center gap-2 flex-wrap">
                        <button className="custom_Button">Italian</button>
                        <button className="custom_Button">French</button>
                        <button className="custom_Button">Asian</button>
                        <button className="custom_Button">European</button>
                  </div>
                </div>

                <div className="AboutYou_container m-auto">

                  <h3 className="text-white">Select Your Gender</h3>

                  <div className="button_container mb-3 d-flex justify-content-center gap-2" style={{ width: "100%" }}>
                    <div className="button_container mb-3 d-flex justify-content-center gap-1 flex-wrap">
                      <button className="custom_Button" style={{ width: "150px" }} >Male</button>
                      <button className="custom_Button" style={{ width: "150px" }} >Female</button>
                      <button className="custom_Button"style={{ width: "150px" }}>Other's</button>
                    </div>
                  </div>

                  <div className="height_container btn_form">
                    <Form.Group>
                      <Form.Control type="number" placeholder="Enter Your Height" min={0} max={200} value={height} onChange={(e) => setHeight(e.target.value)}/>
                    </Form.Group>
                    <p className="text-white mb-0">Enter Your Height</p>
                  </div>
                  <div className="height_container btn_form">
                    <Form.Group>
                      <Form.Control type="number" placeholder="Enter Your Weight" min={0} max={200} value={weight} onChange={(e) => setWeight(e.target.value)}/>
                    </Form.Group>
                    <p className="text-white mb-0">Enter Your Weight</p>
                  </div>
                  <div className="height_container btn_form">
                    <Form.Group>
                      <Form.Control type="number" placeholder="Enter Your Age" min={0} max={100} value={age} onChange={(e) => setAge(e.target.value)}/>
                    </Form.Group>
                    <p className="text-white mb-0">Enter Your Age</p>
                  </div>
                </div>

                <Button className="custom_Button" variant="primary" type="submit">Generate Style</Button>

              </div>
            </form>
            
          </div>
        </div>

        <div className="result-div py-4 py-lg-5">
          <h2 className="mb-5 text-white">Result</h2>
          <Results/>
          <h2 className="mb-5 text-white">Related Result</h2>
          <ProductSlider/>
        </div>
      </div>
    </div>
  );
};
